import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { BusquedaContratosService } from "../../servicios/busqueda-contratos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { BusquedaContratos, BusquedaContratosInput, Aguas, AuxJasper, ParametroJasper, AguaBuscaCuentas } from '../../entidades/entidades';
import { AguasService } from '../../servicios/aguas.service';
import { JasperService } from "../../servicios/jasper.service";
@Component({
  selector: "app-busca-contratos-grid",
  templateUrl: "./busca-contratos-grid.component.html",
  styleUrls: ["./busca-contratos-grid.component.css"],
})
export class BuscaContratosGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  _busquedaContratos: BusquedaContratosInput;
  busquedaContratos: any;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedBusquedaContratos: { [s: string]: BusquedaContratos } = {};
  _busquedaContratosInput: BusquedaContratosInput;
  aguasProceso: Aguas;
  aguaCuenta: string = null;
  public auxJasper: AuxJasper;
  datosAguaCuenta = new AguaBuscaCuentas();

  public idAgua: number;
  public idContrato: number;

  display: boolean = false;
  showDialog() {
      this.display = true;
  }
  
  @Input("esEdoCuenta") esEdoCuenta: boolean = false;
  @Input('busquedaContratosInput') busquedaContratosInput: BusquedaContratosInput;
  @Input("aguaBuscaCuentas") aguaBuscaCuentas: EventEmitter<AguaBuscaCuentas>;

  constructor(
   private busquedaContratosService: BusquedaContratosService,
   private aguasService: AguasService,
  ) {}

  ngOnInit(): void {

    this._busquedaContratos = new BusquedaContratosInput;

    

    if(this.busquedaContratosInput){
      console.log("cuentaAgua: ", this.busquedaContratosInput.cuentaAgua);
      this.aguaCuenta = this.busquedaContratosInput.cuentaAgua;
    }

    this.getAllBusquedaContratos();
    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "id", header: "Id",ordenar: false, styleHeader: "width: 30px;",},
      //{field: "cuentaAgua", header: "Cuenta agua",ordenar: false, styleHeader: "width: 30px;",},
      {field: "numContrato", header: "Num Contrato",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fecha", header: "Fecha",ordenar: true, styleHeader: "width: 150px;",},
      //{field: "idContrato", header: "Id contrato",ordenar: false, styleHeader: "width: 30px;",},
      {field: "contrato", header: "Contrato",ordenar: true, styleHeader: "width: 150px;",},
      {field: "acciones", header: "",ordenar: false, styleHeader: "width: 30px;",},
    ];
  }

  

  //===============================================================
  //Interaccion con servicios
  //===============================================================
  
  async getAllBusquedaContratos() {
    try {
      console.log('envio',  this.aguaCuenta)
      const datoRetorno = await this.busquedaContratosService.getSingle(this.aguaCuenta).toPromise();
      console.log("inforamcion: ", datoRetorno);
      this.busquedaContratos = datoRetorno;
      
      if (Array.isArray(datoRetorno) && datoRetorno.length > 0) {
        const primerElemento = datoRetorno[0].idContrato; // Obtiene un elemento del array
        const id = datoRetorno[0].id;
  
        console.log("Primer elemento:", primerElemento, id);

        this.idAgua = parseInt(id, 10);
        this.idContrato = parseInt(primerElemento, 10);
  
      } else {
        console.error("datoRetorno no es un array válido o está vacío.");
      }
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllBusquedaContratos");
    }
  }
  
  async imprimir(){
    if (this.aguaCuenta != null && this.idContrato != null) {
      // ejemplo de llamada de reporte.
      console.log("imprime");
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "";

       if(this.idContrato == 2 ){
        this.auxJasper.JasperReport.nombreReporte = "ContratoAguaPotable";
       } else if( this.idContrato== 3){
          this.auxJasper.JasperReport.nombreReporte = "ContratoDrenajeSanitario";
       } else if( this.idContrato== 4){
          this.auxJasper.JasperReport.nombreReporte = "ContratoAguaDrenaje";
       } else if( this.idContrato == 5){
          this.auxJasper.JasperReport.nombreReporte = "ContratoProvicionalAguaPotable"
       } else if( this.idContrato == 6){
          this.auxJasper.JasperReport.nombreReporte = "ContratoTomaenCondominio"
       }

      if (this.auxJasper.JasperReport.nombreReporte) {
        this.auxJasper.JasperReport.tipo = "pdf";
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "_id_agua";
        parametroJasper.valor = this.idAgua.toString();
        await this.auxJasper.ParametroJasper.push(parametroJasper);
        await this.showDialog();
      } else {
        await this.muestraMensaje.error("No existe registro del Contrato", "top", "center");
      }
    }
  }
}